import { render, staticRenderFns } from "./sellBillsPaymentDetails.vue?vue&type=template&id=32c532ed"
import script from "./sellBillsPaymentDetails.vue?vue&type=script&lang=js"
export * from "./sellBillsPaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./sellBillsPaymentDetails.vue?vue&type=style&index=0&id=32c532ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports